import React, { Fragment, useContext, useEffect, useRef } from "react";
import { Route, Routes } from "react-router-dom";
import Grid from "@mui/material/Unstable_Grid2";
import Box from "@mui/material/Box";
// import ArcGISMap from "@arcgis/core/Map";
import WebMap from "@arcgis/core/WebMap";
import MapView from "@arcgis/core/views/MapView";
import Portal from "@arcgis/core/portal/Portal";
import DesignerToolSideBar from "./DesignerToolSidebar";
import DesignToolBox from "./DesignToolBox";
import zIndex from "@mui/material/styles/zIndex";

function DesignerTool() {
  var portal = new Portal(); // Defaults to www.arcgis.com
  portal.authMode = "anonymous"; // Set this for anonymous access, (no login required)
  portal.load().then(function () {
    // Do something here
  });
  let areaMapRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    // const map = new ArcGISMap({ basemap: "arcgis-topographic" });
    const webmap = new WebMap({
      portalItem: {
        id: "aa1d3f80270146208328cf66d022e09c",
      },
    });
    const view = new MapView({
      container:
        areaMapRef !== null && areaMapRef.current !== null
          ? areaMapRef.current
          : "",
      map: webmap,
      center: [-118.244, 34.052],
      zoom: 12,
    });
    console.log(" Container:", areaMapRef.current);
    return () => {
      view && view.destroy();
    };
    //eslint-disable-next-line
  }, []);

  return (
    <Grid container className="center-pane">
      <Grid xs={9} className="center-pane">
        <div
          ref={areaMapRef}
          style={{
            width: "100%",
            height: "100%",
            padding: 20,
            margin: 3,
            borderStyle: "groove",
            borderColor: "pallete.primary.contrast",
          }}
        >
          <DesignToolBox />
        </div>
      </Grid>

      <Grid xs={3}>
        <DesignerToolSideBar />
      </Grid>
    </Grid>
  );
}

export default DesignerTool;
